import React from "react"
import {Formik} from "formik"
import * as Yup from "yup"
import FullNameInput from "../../../FullName/FullName"
import AddressComponent from "../../../Address/Address"
import DocumentTypeHeader from "./DocumentTypeHeader"
import {ApplicationDocumentType} from "../../../../resources/application"
import {AddressVerificationDocumentFormValues} from "./types"
import {addressValidation, fullNameValidation} from "./validationSchemas"

interface AddressVerificationDocumentFormProps {
	documentType: ApplicationDocumentType
	initialValues: AddressVerificationDocumentFormValues
	onSubmit: (values: AddressVerificationDocumentFormValues) => void
	formId: string
}

const validationSchema = Yup.object().shape({
	fullName: fullNameValidation,
	address: addressValidation,
})

export const AddressVerificationDocumentForm = ({
	documentType,
	initialValues,
	onSubmit,
	formId,
}: AddressVerificationDocumentFormProps) => {
	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
			{({values, handleChange, handleBlur, handleSubmit, setFieldValue}) => (
				<form onSubmit={handleSubmit} id={formId} className="edit-document-form">
					<div className="key-value-card-container-key">Type</div>
					<DocumentTypeHeader documentType={documentType} />

					<div className="key-value-card-container-key">Name</div>
					<div className="form-row two">
						<FullNameInput fullName={values.fullName} handleChange={handleChange} handleBlur={handleBlur} />
					</div>

					<div className="key-value-card-container-key">Address</div>
					<AddressComponent
						closed={false}
						namePrefix="address."
						street={values.address.street}
						street2={values.address.street2}
						city={values.address.city}
						state={values.address.state ?? ""}
						postalCode={values.address.postalCode}
						country={values.address.country}
						isUsOnlyAddress={false}
						handleChange={handleChange}
						handleBlur={handleBlur}
						setFieldValue={setFieldValue}
					/>
				</form>
			)}
		</Formik>
	)
}
